import { isElectron } from '@libs/utils/envUtils'

const tryCallWindowApi = async (action: string, ...args: unknown[]) => {
  if (typeof electronAPI === 'undefined' || typeof electronAPI.wnd !== 'function') {
    return false
  }

  try {
    await electronAPI.wnd(action, ...args)
    return true
  } catch {
    return false
  }
}

export const initializeElectronPerformance = async () => {
  if (!isElectron()) {
    return
  }

  // The host should map one of these actions to BrowserWindow/webContents
  // background throttling controls. Unsupported actions are ignored.
  if (await tryCallWindowApi('setBackgroundThrottling', false)) {
    return
  }
  if (await tryCallWindowApi('disableBackgroundThrottling')) {
    return
  }
  await tryCallWindowApi('setIgnoreBackgroundThrottling', true)
}
